export enum ExportTableTypes {
  Employee = 'Employee',
  Invoice = 'Invoice',
  Overview = 'Overview',
  Position = 'Positions',
  Department = 'Department'
}
